import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  BALANCES_LIST_QUERY_KEY,
  BALANCES_PERMISSIONS,
} from '@modules/balances/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IBalancesSavePayload } from '../types';
import {
  BALANCES_EDIT_MUTATION_KEY,
  BALANCES_EDIT_URL,
} from '../constants';

export default function useBalancesEditMutation(): IContextMutationResult<
  void,
  Error,
  IBalancesSavePayload
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IBalancesSavePayload>({
    mutationKey: [BALANCES_EDIT_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPost<void>(
      BALANCES_EDIT_URL,
      {
        affiliate_cashout: {
          ...payload,
          affiliate_id: id,
        },
      },
      {
        permission: BALANCES_PERMISSIONS.EDIT,
        urlParams: { id },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('success');
      void queryClient.invalidateQueries({ queryKey: [BALANCES_LIST_QUERY_KEY] });
    },
  });
}
